import { connect } from 'react-redux';

import UsageMainOptionsBar from '../../components/usage/UsageMainOptionsBar';
import {
  getMetainf,
  getUsageChartOptions,
  getUsageGroupColumn,
  getUsageQueryType,
  getUsageSplitColumn,
} from '../../reducers/analyticsApp';
import {
  changeUsageView,
  setUsageGroupColumn,
  setUsageQueryType,
  setUsageSplitColumn,
} from '../../actions/usage';
import { getUsageEventName } from '../../utils/usage';

const getEventName = (state) =>
  getUsageEventName(getUsageQueryType(state), getUsageGroupColumn(state));

const mapStateToProps = (state) => {
  return {
    metainf: getMetainf(state, getEventName(state)),
    groupColumn: getUsageGroupColumn(state),
    splitColumn: getUsageSplitColumn(state),
    queryType: getUsageQueryType(state),
    view: getUsageChartOptions(state).view,
    viewOptions: getUsageChartOptions(state).views,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChangeGroupColumn: (value) => dispatch(setUsageGroupColumn(value)),
  onChangeSplitColumn: (value) => dispatch(setUsageSplitColumn(value)),
  onChangeQueryType: (value) => dispatch(setUsageQueryType(value)),
  onChangeView: (value) => dispatch(changeUsageView(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageMainOptionsBar);
